<template>
  <section class="btz">
    <h2 class="btz-title">{{ $t('homeNew.basicTrainingZone.title') }}</h2>
    <p class="btz-subtitle">{{ $t('homeNew.basicTrainingZone.subtitle') }}</p>

    <div class="btz-tabs">
      <button
        v-for="(tabName, index) in tabNames"
        :key="tabName"
        type="button"
        class="btz-tab"
        :class="{ 'btz-tab--active': activeTab === index }"
        @click="activeTab = index"
      >
        {{ tabName }}
      </button>
    </div>

    <div
      v-for="(tabName, index) in tabNames"
      v-show="activeTab === index"
      :key="'panel-' + tabName"
      class="btz-panel"
    >
      <div class="btz-image-wrap">
        <picture>
          <source media="(max-width: 899px)" :srcset="tabImages[index].img375" />
          <source media="(max-width: 1279px)" :srcset="tabImages[index].img900" />
          <source media="(max-width: 1639px)" :srcset="tabImages[index].img1280" />
          <img
            class="btz-image"
            :class="{ 'btz-image--top': index >= 2 }"
            :src="tabImages[index].img1640"
            :alt="tabName"
          />
        </picture>
      </div>
      <div class="btz-text">
        <h3 class="btz-section-title">{{ $t('homeNew.basicTrainingZone.principleTitle') }}</h3>
        <p class="btz-section-text">{{ $t('homeNew.basicTrainingZone.tabs.' + index + '.principleText') }}</p>
        <h3 class="btz-section-title btz-section-title--spaced">{{ $t('homeNew.basicTrainingZone.whyTitle') }}</h3>
        <p class="btz-section-text">{{ $t('homeNew.basicTrainingZone.tabs.' + index + '.whyText') }}</p>
        <a href="/basic-zone" class="btz-button">{{ $t('homeNew.basicTrainingZone.learnMore') }}</a>
      </div>
    </div>
  </section>
</template>

<script>
import basic1_375 from '@/assets/img/main-btz/basic_1_375.jpg';
import basic1_900 from '@/assets/img/main-btz/basic_1_900.jpg';
import basic1_1280 from '@/assets/img/main-btz/basic_1_1280.jpg';
import basic1_1640 from '@/assets/img/main-btz/basic_1_1640.jpg';

import basic2_375 from '@/assets/img/main-btz/basic_2_375.jpg';
import basic2_900 from '@/assets/img/main-btz/basic_2_900.jpg';
import basic2_1280 from '@/assets/img/main-btz/basic_2_1280.jpg';
import basic2_1640 from '@/assets/img/main-btz/basic_2_1640.jpg';

import basic3_375 from '@/assets/img/main-btz/basic_3_375.jpg';
import basic3_900 from '@/assets/img/main-btz/basic_3_900.jpg';
import basic3_1280 from '@/assets/img/main-btz/basic_3_1280.jpg';
import basic3_1640 from '@/assets/img/main-btz/basic_3_1640.jpg';

import basic4_375 from '@/assets/img/main-btz/basic_4_375.jpg';
import basic4_900 from '@/assets/img/main-btz/basic_4_900.jpg';
import basic4_1280 from '@/assets/img/main-btz/basic_4_1280.jpg';
import basic4_1640 from '@/assets/img/main-btz/basic_4_1640.jpg';

export default {
  name: 'MainBasicTrainingZone',
  data() {
    return {
      activeTab: 0,
      tabNames: ['Milon', 'Power Plate', 'CLMBR', 'NordicTrack'],
      tabImages: [
        {
          img375: basic1_375,
          img900: basic1_900,
          img1280: basic1_1280,
          img1640: basic1_1640,
        },
        {
          img375: basic2_375,
          img900: basic2_900,
          img1280: basic2_1280,
          img1640: basic2_1640,
        },
        {
          img375: basic3_375,
          img900: basic3_900,
          img1280: basic3_1280,
          img1640: basic3_1640,
        },
        {
          img375: basic4_375,
          img900: basic4_900,
          img1280: basic4_1280,
          img1640: basic4_1640,
        },
      ],
    };
  },
};
</script>

<style scoped>
.btz {
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 40px;
}

@media screen and (min-width: 768px) {
  .btz {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media screen and (min-width: 1024px) {
  .btz {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media screen and (min-width: 1440px) {
  .btz {
    padding-left: 80px;
    padding-right: 80px;
    margin-bottom: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .btz {
    padding-left: 120px;
    padding-right: 120px;
    margin-bottom: 80px;
  }
}

.btz-title {
  margin: 32px 0 0;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 768px) {
  .btz-title {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .btz-title {
    margin-top: 60px;
    font-size: 40px;
  }
}

@media screen and (min-width: 1440px) {
  .btz-title {
    font-size: 48px;
  }
}

@media screen and (min-width: 1920px) {
  .btz-title {
    font-size: 54px;
  }
}

.btz-subtitle {
  margin: 16px 0 0;
  width: 100%;
  line-height: 1.2;
  font-size: 18px;
  font-weight: 400;
  color: #000;
}

@media screen and (min-width: 768px) {
  .btz-subtitle {
    margin-top: 24px;
  }
}

@media screen and (min-width: 1024px) {
  .btz-subtitle {
    font-size: 22px;
  }
}

@media screen and (min-width: 1440px) {
  .btz-subtitle {
    font-size: 24px;
  }
}

@media screen and (min-width: 1920px) {
  .btz-subtitle {
    font-size: 26px;
  }
}

.btz-tabs {
  display: flex;
  gap: 24px;
  margin-top: 32px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.btz-tabs::-webkit-scrollbar {
  display: none;
}

@media screen and (min-width: 1024px) {
  .btz-tabs {
    margin-top: 48px;
  }
}

.btz-tab {
  flex-shrink: 0;
  width: 160px;
  height: 48px;
  border-radius: 24px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  cursor: pointer;
  padding: 8px 12px;
  box-sizing: border-box;
}

@media screen and (min-width: 768px) {
  .btz-tab {
    height: 68px;
    width: 200px;
    font-size: 24px;
  }
}

@media screen and (min-width: 1280px) {
  .btz-tab {
    height: 104px;
  }
}

@media screen and (min-width: 1920px) {
  .btz-tab {
    font-size: 26px;
  }
}

.btz-tab--active {
  background: #000;
  color: #fff;
  border-color: #000;
}

.btz-panel {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}

@media screen and (min-width: 900px) {
  .btz-panel {
    flex-direction: row;
    align-items: center;
    gap: 24px;
    height: 700px;
  }
}

@media screen and (min-width: 1024px) {
  .btz-panel {
    gap: 40px;
    margin-top: 40px;
  }
}

@media screen and (min-width: 1440px) {
  .btz-panel {
    height: 542px;
  }
}

@media screen and (min-width: 1920px) {
  .btz-panel {
    height: 808px;
  }
}

.btz-image-wrap {
  width: 100%;
  aspect-ratio: 1.6 / 1;
  border-radius: 24px;
  overflow: hidden;
  flex-shrink: 0;
}

.btz-image-wrap picture {
  display: block;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 900px) {
  .btz-image-wrap {
    order: 2;
    aspect-ratio: auto;
    width: auto;
    flex: 1;
    min-width: 0;
    height: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .btz-image-wrap {
    flex: none;
    width: 430px;
  }
}

@media screen and (min-width: 1280px) {
  .btz-image-wrap {
    width: 686px;
  }
}

@media screen and (min-width: 1440px) {
  .btz-image-wrap {
    width: 604px;
  }
}

@media screen and (min-width: 1640px) {
  .btz-image-wrap {
    width: 804px;
  }
}

@media screen and (min-width: 1920px) {
  .btz-image-wrap {
    flex: 1;
    width: auto;
  }
}

.btz-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.btz-image--top {
  object-position: top;
}

.btz-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 24px;
}

@media screen and (min-width: 900px) {
  .btz-text {
    order: 1;
    width: 420px;
    flex-shrink: 0;
    margin-top: 0;
    min-height: 0;
  }
}

@media screen and (min-width: 1024px) {
  .btz-text {
    width: auto;
    flex: 1;
    min-width: 0;
  }
}

@media screen and (min-width: 1920px) {
  .btz-text {
    width: 660px;
    flex: none;
  }
}

.btz-section-title {
  margin: 0;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.2;
  color: #000;
}

.btz-section-title + .btz-section-text {
  margin: 2px 0 0;
}

.btz-section-title--spaced {
  margin-top: 24px;
}

.btz-section-text {
  margin: 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  color: #000;
}

.btz-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 44px;
  margin-top: 24px;
  border-radius: 22px;
  background: #000;
  color: #fff;
  font-size: 22px;
  font-weight: 400;
  line-height: 1;
  text-decoration: none;
  flex-shrink: 0;
  align-self: center;
}

@media screen and (min-width: 900px) {
  .btz-button {
    align-self: flex-start;
  }
}

@media screen and (min-width: 768px) {
  .btz-section-text {
    font-size: 20px;
  }

  .btz-button {
    font-size: 24px;
  }
}

@media screen and (min-width: 1280px) {
  .btz-section-title--spaced {
    margin-top: 40px;
  }

  .btz-button {
    margin-top: 40px;
  }
}

@media screen and (min-width: 1920px) {
  .btz-section-title {
    font-size: 28px;
  }

  .btz-section-title + .btz-section-text {
    margin-top: 4px;
  }

  .btz-section-title--spaced {
    margin-top: 52px;
  }

  .btz-section-text {
    font-size: 26px;
  }

  .btz-button {
    margin-top: 52px;
  }
}
</style>
